import { TouchableOpacity } from 'react-native'
import { H6, SizableText, styled, XStack, YStack } from 'tamagui'
import { DesignSystem } from '@/src/design-system'
import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { CircleWarning } from '@/src/assets/icons/CircleWarning'
import { router } from 'expo-router'
import * as MortgageEarn from '@/src/experiences/mortgage-earn'

const StyledCircleWarning = styled(
  CircleWarning,
  {},
  {
    accept: { color: 'color' } as const,
  },
)

export function AwardAmount({
  amount,
  needsAttention,
}: {
  amount: number
  needsAttention: boolean
}) {
  return (
    <TouchableOpacity
      style={{ flexGrow: 1 }}
      onPress={() => router.push(MortgageEarn.Navigation.Routes.MortgageEarn.route)}
      activeOpacity={0.5}
    >
      <DesignSystem.Card style={{ flexGrow: 1 }}>
        <YStack gap="$8" flex={1}>
          <H6>{amount.toLocaleString()} Mesa Points</H6>
          <XStack justify="space-between" items="center">
            <SizableText size="$3" opacity={0.75}>
              Award Amount
            </SizableText>
            <XStack items="center" gap="$0.5">
              {needsAttention && <StyledCircleWarning color="$textError" />}
              <ChevronRight />
            </XStack>
          </XStack>
        </YStack>
      </DesignSystem.Card>
    </TouchableOpacity>
  )
}
